// @flow
import * as React from 'react';
import styled from 'styled-components';
import Box from 'components/Box';
import Input from 'components/Input';
import { Error } from 'components/Form/Field';
import { colors } from '../theme';

const { useState, useRef } = React;

const ErrorMessage = styled(Error)`
  /* stylelint */
`;

const HiddenInput = styled.input`
  position: absolute;
  z-index: 1;
  bottom: 0;
  left: 0;
  opacity: 0;
  height: 0;
  width: 100%;
  padding: 0;
  margin: 0;
  pointer-events: none;

  &:invalid {
    & + input,
    & + * input {
      &:not(:focus) {
        box-shadow: 0 0 0 1px ${colors.scarlet};
        border-color: ${colors.scarlet};
      }
    }
    & ~ ${ErrorMessage} {
      display: flex;
    }
  }

  & ~ ${ErrorMessage} {
    display: none;
  }
`;

const DelimitedInput = ({
  max: maxProp,
  min: minProp,
  value,
  type,
  name,
  id,
  onChange,
  noDecimal,
  errorMessage,
  onBlur,
  ...props
}: {
  max?: number | string,
  min?: number | string,
  value?: ?string,
  type?: string,
  name?: string,
  id?: string,
  onChange?: Function,
  noDecimal?: boolean,
  errorMessage?: string,
  onBlur?: Function
}) => {
  const containerRef: any = useRef(null);

  const [displayValue, setDisplayValue] = useState(
    value ? parseFloat(value).toLocaleString(USER_LOCALE) : value || ''
  );
  const [touched, setTouched] = useState(false);

  const max = maxProp ? parseFloat(maxProp) : null;
  const min = minProp ? parseFloat(minProp) : null;

  const update = e => {
    const numberString = noDecimal
      ? e.target.value.replace(/[^0-9]/g, '')
      : e.target.value.replace(/[^0-9.]/g, '');
    const number = parseFloat(numberString);
    const [whole, fraction] =
      max && number > max ? [max] : numberString.split('.');
    const delimitedWhole = whole
      ? parseFloat(whole).toLocaleString(USER_LOCALE)
      : '';
    const decimal = fraction || fraction === '' ? `.${fraction}` : '';
    const display = `${delimitedWhole}${decimal}`;
    setDisplayValue(display);
    if (onChange) {
      onChange({
        ...e,
        target: {
          ...e.target,
          value: parseFloat(display.replace(/,/g, ''))
        }
      });
    }
  };

  const onHiddenChange = e => {
    if (containerRef && containerRef.current) {
      const input: HTMLElement = containerRef.current.querySelector(
        'input:not([data-no-tab="true"])'
      );
      if (input) {
        update(e);
        input.focus();
      }
    }
  };

  const onBlurHandler = e => {
    if (!touched) {
      setTouched(true);
    }
    if (onBlur) {
      onBlur(e);
    }
  };

  return (
    <div ref={containerRef} style={{ width: '100%' }}>
      <Box position="relative" width="100%">
        <HiddenInput
          value={value || ''}
          min={min}
          max={max}
          type="number"
          name={`${name || 'a'}-number`}
          aria-labelledby={id && `${id}-label`}
          tabIndex={-1}
          data-no-tab="true"
          onChange={onHiddenChange}
        />{' '}
        <Input
          type={type}
          onChange={update}
          value={displayValue}
          name={name}
          id={id}
          onBlur={onBlurHandler}
          {...props}
        />
        {errorMessage && touched && (
          <ErrorMessage errorMessage={errorMessage} />
        )}
      </Box>
    </div>
  );
};

export default DelimitedInput;
